import type { BasedFunctionConfig } from '@based/sdk/functions'

export default {
  type: 'query',
  name: 'get-messages',
  public: false,
} as BasedFunctionConfig
